module.exports = __webpack_public_path__ + "media/Components/fonts/Ralewayitalic-13a12e09e6474018e7c80926bd663d4f.ttf";